<template>
  <v-main class="page">
    <v-container fluid fill-height>
      <!-- Language Selector at top right -->
      <div class="lang-selector">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" color="primary">
              <span class="mr-1">{{ currentFlag }}</span> {{ currentLangName }}
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="lang in langs"
              :key="lang.code"
              @click="changeLocale(lang.code)"
            >
              <v-list-item-title
                >{{ lang.flag }} {{ lang.name }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5" lg="4">
          <v-card elevation="10" class="rounded-xl pa-8">
            <div class="text-center mb-6">
              <v-avatar rounded width="240" class="mb-4">
                <img alt="Logo" src="/logos/logo_inline.svg" />
              </v-avatar>
              <h1 class="display-1 font-weight-bold primary--text mb-2">
                {{ $t('login.title') }}
              </h1>
              <p class="subtitle-1 grey--text text--darken-1 px-4">
                {{ $t('login.subtitle') }}
              </p>
            </div>

            <v-form @submit.prevent="login">
              <v-text-field
                id="email"
                v-model="email"
                outlined
                prepend-inner-icon="mdi-account-outline"
                name="email"
                :label="$t('login.emailLabel')"
                type="text"
                class="rounded-lg mb-2"
                color="primary"
                hide-details="auto"
              >
              </v-text-field>

              <v-text-field
                id="password"
                v-model="password"
                outlined
                prepend-inner-icon="mdi-lock-outline"
                name="password"
                :label="$t('login.passwordLabel')"
                type="password"
                class="rounded-lg mb-4"
                color="primary"
                hide-details="auto"
              >
              </v-text-field>

              <v-alert
                v-if="errorMessage"
                type="error"
                text
                dense
                class="rounded-lg mb-4"
              >
                {{ errorMessage }}
              </v-alert>

              <v-btn
                block
                large
                depressed
                color="primary"
                class="rounded-lg py-6 font-weight-bold"
                size="large"
                @click="login"
                :loading="isLoading"
              >
                {{ $t('login.button') }}
              </v-btn>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { projectAuth, signInWithEmailAndPassword } from '@/firebase/config'

export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      isLoading: false,
      errorMessage: '',
      langs: [
        { code: 'pt-br', name: 'Português', flag: '🇧🇷' },
        { code: 'en-us', name: 'English', flag: '🇺🇸' },
        { code: 'es-ar', name: 'Español', flag: '🇦🇷' },
      ],
    }
  },
  computed: {
    currentFlag() {
      const current = this.langs.find((l) => l.code === this.$i18n.locale)
      return current ? current.flag : '🌐'
    },
    currentLangName() {
      const current = this.langs.find((l) => l.code === this.$i18n.locale)
      return current ? current.name : ''
    },
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
    },
    async login() {
      this.isLoading = true
      this.errorMessage = ''

      return signInWithEmailAndPassword(projectAuth, this.email, this.password)
        .then(
          () => {
            this.$router.push('/')
          },
          (error) => {
            const errorCode = error.code
            console.error('Login error:', error)

            switch (errorCode) {
              case 'auth/invalid-email':
                this.errorMessage = this.$t('login.errors.invalidEmail')
                break
              case 'auth/wrong-password':
                this.errorMessage = this.$t('login.errors.wrongPassword')
                break
              case 'auth/user-not-found':
                this.errorMessage = this.$t('login.errors.generic')
                break
              default:
                this.errorMessage = this.$t('login.errors.generic')
            }
          }
        )
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  background-color: #f3f6fb !important; // Match $bg-1
  min-height: 100vh;
}

.lang-selector {
  position: absolute;
  top: 20px;
  right: 20px;
}

.v-card {
  background-color: #ffffff !important;
}
</style>
